import React, {useEffect, useState} from "react";
import {useEditor} from "../contexts/EditorContext";
import {toast} from "react-toastify";
import {getCustomCSS, updateCustomCSS} from "../services/ApiHelper";
import CustomCSSInput from "../../Pages/UIBuilder/Components/CustomCSSInput";
import {validateCSS} from "../../Pages/UIBuilder/Components/UIBuilderHelper";

type CustomCSSProps = {
    id?: string;
    projectId: string;
}
export type CustomCSSModel = {
    globalStyles: string;
}

const CustomCSS = ({ id, projectId}: CustomCSSProps) => {
    const baseId = id || 'custom-css';
    const {uiModel, customCSS, setCustomCSS} = useEditor();
    const [error, setError] = useState(false);

    useEffect(() => {
        getCSSFromNetWork();
    }, []);

    const getCSSFromNetWork = async () => {
        try {
            const responseData = await getCustomCSS(projectId, uiModel?.id ?? '');
            if (responseData?.done && responseData?.data?.globalStyles) {
                setCustomCSS(responseData.data)
            } else {
                setCustomCSS({globalStyles: ''})
            }
        } catch (error) {
            console.log(error, 'Error');
        }
    }

    const updateCustomCSSNetWork = async () => {
        try {
            const responseData = await updateCustomCSS(projectId, uiModel?.id ?? '', customCSS);
            if (responseData?.done) {
                toast.success("Updated CSS");
            }
        } catch (error) {
            console.log(error, 'Error');
        }
    }

    const handleCssChange = (cssValue: string) => {
        const validationResult = validateCSS(cssValue).isValid;
        
        if (validationResult) {
            setCustomCSS({...customCSS, globalStyles: cssValue})
            setError(false);
        } else {
            setError(true);
        }
    }
    return (
        <div id={baseId} data-testid={baseId} className='tw-p-[31px] tw-w-full'>
            <div id={`${baseId}-title`} className="tw-justify-start tw-text-[#969fae] tw-text-base tw-font-semibold tw-mb-3 ">Add custom styles to the runtime</div>
            <div id={`${baseId}-input-wrapper`} className="tw-w-full">
                <CustomCSSInput
                    className='tw-ms-0 tw-me-0 tw-w-full xl:tw-w-3/4'
                    initialValue={customCSS?.globalStyles ?? ''}
                    showTitle={false}
                    onChange={handleCssChange}  />
            </div>
            <button id={`${baseId}-save-btn`} data-testid={`${baseId}-save-btn`} disabled={error} onClick={async () => updateCustomCSSNetWork()} className='popup-button-filled tw-mt-4'>{'Save'}</button>
        </div>
    );
}

export default CustomCSS;